import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dataV from '@jiaminghi/data-view'
import './styles/index.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import TButton from './components/TButton/index.vue'
// 分页组件
import Pagination from '@/components/Pagination'
import TlbsMap from 'tlbs-map-vue';

// import './permission' // permission control

Vue.component('Pagination', Pagination)

Vue.config.productionTip = false
Vue.component('TButton', TButton)
Vue.use(dataV)
Vue.use(ElementUI)
Vue.use(TlbsMap)
Vue.prototype.$wsurl = 'ws' + window.location.origin.slice(4)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
